import { render, staticRenderFns } from "./PricingFour.vue?vue&type=template&id=d9a259b4&"
import script from "./PricingFour.vue?vue&type=script&lang=js&"
export * from "./PricingFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports